import Select from 'react-select';
import style from '@/modules/Note/Note.module.scss';
import SelectDropdownRow from '@/components/SelectDropdownRow/index.tsx';
import { ProviderNoteTemplate, selectCurrentVisitStatus, useAppSelector } from '@ax/redux-store';
import { NOTE_STATUS } from '@ax/constants';

interface ProviderNoteTemplatesProps {
  selectedTemplate?: ProviderNoteTemplate;
  onValueChanged?: (selectedOption: { value: string; label: string }) => void;
  templates?: ProviderNoteTemplate[];
}

const ProviderNoteTemplates = ({
  templates,
  onValueChanged,
  selectedTemplate,
}: ProviderNoteTemplatesProps) => {
  const noteId = useAppSelector((state) => state.selectedVisit?.uuid);
  const noteStatus = useAppSelector(selectCurrentVisitStatus(noteId));

  return (
    <>
      {templates && (
        <Select
          // @ts-ignore
          getOptionLabel={(option) => (
            <SelectDropdownRow
              option={option}
              showBetaIcon={false}
            />
          )}
          isDisabled={
            noteStatus === NOTE_STATUS.NOTE_UPLOADED_TO_MDS ||
            noteStatus === NOTE_STATUS.NOTE_UPLOADED_TO_EHR ||
            noteStatus === NOTE_STATUS.CONTENT_PROCESSING
          }
          classNames={{
            dropdownIndicator: () => {
              return style.custom_dropdown_indicator;
            },
          }}
          value={
            selectedTemplate
              ? { value: selectedTemplate?.templateId, label: selectedTemplate?.templateName }
              : null
          }
          classNamePrefix="select"
          onChange={(selectedOption) => {
            onValueChanged?.(selectedOption as { label: string; value: string });
          }}
          options={templates.map((template) => {
            return { value: template.templateId, label: template.templateName };
          })}
          theme={(theme) => ({
            ...theme,
            colors: {
              ...theme.colors,
              primary: '#344bc6',
              neutral20: '#e0e0e0',
              neutral30: '#e0e0e0',
            },
          })}
        />
      )}
    </>
  );
};

export default ProviderNoteTemplates;
